// extracted by mini-css-extract-plugin
module.exports = {"thlargeIcon":"filter-panel-thlargeicon_thlargeIcon__3S-ao"};